module.exports = __webpack_public_path__ + "static/media/28.32a8b575.jpg";